import React, { useState, useEffect } from 'react';
import '../crm.css';

const stageOptions = [
    { value: 'new', label: 'New' },
    { value: 'qualified', label: 'Qualified' },
    { value: 'proposal', label: 'Proposal' },
    { value: 'site_visit', label: 'Site Visit' },
    { value: 'negotiation', label: 'Negotiation' },
    { value: 'won', label: 'Won' },
    { value: 'lost', label: 'Lost' }
];

const DealForm = ({ deal, onSubmit, onCancel, loading, showCancel = true }) => {
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        value: 0,
        currency: 'INR',
        stage: 'new',
        expectedCloseDate: '',
        contactId: '',
        contactName: '', // Fallback or display name
        notes: ''
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (deal) {
            setFormData({
                title: deal.title || '',
                description: deal.description || '',
                value: deal.value || 0,
                currency: deal.currency || 'INR',
                stage: deal.stage || 'new',
                expectedCloseDate: deal.expectedCloseDate ? deal.expectedCloseDate.split('T')[0] : '',
                contactId: deal.contactId || '',
                contactName: deal.contactName || '',
                notes: deal.notes || ''
            });
        }
    }, [deal]);

    const validate = () => {
        const newErrors = {};
        if (!formData.title.trim()) newErrors.title = 'Title is required';
        if (formData.value === '' || formData.value < 0) newErrors.value = 'Valid value is required';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            onSubmit(formData);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="crm-form">
            <div className="crm-form-group">
                <label className="crm-label required">Deal Title</label>
                <input
                    type="text"
                    className={`crm-input ${errors.title ? 'error' : ''}`}
                    value={formData.title}
                    onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                    placeholder="e.g. Annual Maintenance Contract"
                    disabled={loading}
                />
                {errors.title && <span className="crm-error">{errors.title}</span>}
            </div>

            <div className="crm-form-row">
                <div className="crm-form-group">
                    <label className="crm-label required">Value (₹)</label>
                    <input
                        type="number"
                        className={`crm-input ${errors.value ? 'error' : ''}`}
                        value={formData.value}
                        onChange={(e) => setFormData({ ...formData, value: parseFloat(e.target.value) || 0 })}
                        min="0"
                        disabled={loading}
                    />
                    {errors.value && <span className="crm-error">{errors.value}</span>}
                </div>
                <div className="crm-form-group">
                    <label className="crm-label">Stage</label>
                    <select
                        className="crm-select"
                        value={formData.stage}
                        onChange={(e) => setFormData({ ...formData, stage: e.target.value })}
                        disabled={loading}
                    >
                        {stageOptions.map(opt => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                    </select>
                </div>
            </div>

            <div className="crm-form-row">
                <div className="crm-form-group">
                    <label className="crm-label">Expected Close Date</label>
                    <input
                        type="date"
                        className="crm-input"
                        value={formData.expectedCloseDate}
                        onChange={(e) => setFormData({ ...formData, expectedCloseDate: e.target.value })}
                        disabled={loading}
                    />
                </div>
                <div className="crm-form-group">
                    <label className="crm-label">Contact Name</label>
                    <input
                        type="text"
                        className="crm-input"
                        value={formData.contactName}
                        onChange={(e) => setFormData({ ...formData, contactName: e.target.value })}
                        placeholder="Associated Contact"
                        disabled={loading}
                    />
                </div>
            </div>

            <div className="crm-form-group">
                <label className="crm-label">Description</label>
                <textarea
                    className="crm-textarea"
                    value={formData.description}
                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                    rows={3}
                    placeholder="Deal details..."
                    disabled={loading}
                />
            </div>

            <div className="crm-form-group">
                <label className="crm-label">Notes</label>
                <textarea
                    className="crm-textarea"
                    value={formData.notes}
                    onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                    rows={2}
                    placeholder="Internal notes..."
                    disabled={loading}
                />
            </div>

            <div className="crm-form-actions">
                {showCancel && (
                    <button
                        type="button"
                        className="crm-btn crm-btn-secondary"
                        onClick={onCancel}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                )}
                <button
                    type="submit"
                    className="crm-btn crm-btn-primary"
                    disabled={loading}
                >
                    {loading ? 'Saving...' : 'Save Deal'}
                </button>
            </div>
        </form>
    );
};

export default DealForm;
